
export default {
  computed: {
    hasError() {
      return Boolean(this.error?.message)
    },

    error() {
      return this.$route?.params?.login_error
    },
  },
}
